export default function NoResultsIcon() {
  return (
    <svg
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.24"
        d="M14.3999 45.6004C14.3999 41.6239 17.6235 38.4004 21.5999 38.4004H98.3999C102.376 38.4004 105.6 41.6239 105.6 45.6004V74.4004C105.6 78.3768 102.376 81.6004 98.3999 81.6004H21.5999C17.6235 81.6004 14.3999 78.3768 14.3999 74.4004V45.6004Z"
        fill="#919EAB"
      />
      <rect opacity="0.48" x="51.6001" y="51.5996" width="19.2" height="6" rx="3" fill="#919EAB" />
      <rect opacity="0.24" x="51.6001" y="62.4004" width="38.4" height="6" rx="3" fill="#919EAB" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.991 51.9994L43.9448 64.8514C44.5327 65.7903 44.5526 66.9658 43.9967 67.923C43.3618 68.9735 42.199 69.6132 40.9479 69.6002H25.0403C23.7805 69.6049 22.6157 68.9486 21.9915 67.8826C21.4517 66.9357 21.4715 65.7802 22.0433 64.8514L29.9971 51.9994C30.6507 51.0032 31.7805 50.4004 32.9941 50.4004C34.2076 50.4004 35.3374 51.0032 35.991 51.9994ZM31.3715 65.6004C31.3715 66.484 32.1007 67.2004 33.0001 67.2004C33.8995 67.2004 34.6287 66.484 34.6287 65.6004C34.6287 64.7167 33.8995 64.0004 33.0001 64.0004C32.1007 64.0004 31.3715 64.7167 31.3715 65.6004ZM33.0001 62.4004C33.8995 62.4004 34.6287 61.684 34.6287 60.8004V54.4004C34.6287 53.5167 33.8995 52.8004 33.0001 52.8004C32.1007 52.8004 31.3715 53.5167 31.3715 54.4004V60.8004C31.3715 61.684 32.1007 62.4004 33.0001 62.4004Z"
        fill="#919EAB"
      />
    </svg>
  );
}
